<template>
    <div class='form-group'>
        <label v-if='label'>
            {{ label }}
            <span v-if='required' class='text-danger'>*</span>
            <font-awesome-icon icon="info-circle" class="ms-1 text-info" v-if="info" v-tooltip="info" /><br>
            <small v-if='subInfo' class='text-info d-block' style="margin-top: -5px">{{ subInfo }}</small>
        </label>
        <div :class="['input-weight', {'input-weight-error': errors && errors.length }]" >
            <div class='col-sm-12 mb-2'
                 v-for='(weight, key) in model' :key="key">
                <label class='mb-0'>
                    {{ weight.name }}
                    ({{ weight.value ?? 0 }} %)
                </label>
                <el-slider :max='100' :min='0' :step="step" show-stops v-model='weight.value' :disabled="disabled" />
            </div>
            
            <div
                class='fw-bold px-4 text-center'
                :class='{"text-danger": percentageRemaining < 0 || percentageRemaining > 0, "text-success": percentageRemaining === 0}'>
                Percentual restante: {{ percentageRemaining }}%
            </div>
        </div>
        
        <div v-if='errors && errors.length' class='invalid-feedback d-flex' v-for='(error, index) in errors'
             :key='`invalid-feedback-${index}`'> {{ error }}
        </div>
        
    </div>
</template>

<script setup>
    import { computed, onMounted, ref, watch } from 'vue';
    import { ElSlider } from 'element-plus';
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
    
    const emit = defineEmits(['update:modelValue']);
    
    const props = defineProps({
        label: { type: String, default: null },
        placeholder: { type: String, default: '' },
        required: { type: Boolean, default: false },
        disabled: { type: Boolean, default: false },
        errors: { default: null },
        modelValue: { type: [Array] },
        options: { type: [Array], default: [] },
        step: { type: Number, default: 1 },
        info: { type: String, default: '' },
        subInfo: { type: String, default: '' }
    });
    
    const model = computed({
        get: () => props.modelValue,
        set: (value) => emit('update:modelValue', buildWeights(value))
    });
    
    const updateValue = (event) => {
        emit('update:modelValue', event.target.value);
    };

    const percentageRemaining = computed(() => {
        let percentage = 100;
        const sum = model.value
            ?.map(item => item?.value)
            ?.reduce((acc, valor) => acc + valor, 0);
        return percentage - sum;
    });
    
    const defineWeights = () => {
        const weights = [];
        
        for (const option of props.options) {
            weights.push({ name: option, value: 0 });
        }
        
        if (!model.value?.length) {
            model.value = weights;
        }
    }
    
    const buildWeights = (weights) => {
        const data = [];
        
        for (const option of props.options) {
            const value = !!weights
                ? weights.find(item => item?.name === option)
                : null;
            
            if (value) data.push(value);
            else data.push({ name: option, value: 0 });
        }
        
        return data;
    }
    
    onMounted(() => {
        defineWeights();
    });
    
    watch(() => props.options, () => {
        defineWeights();
    });
    
    defineExpose({
        buildWeights,
    });
</script>

<style scoped>
    .input-weight {
        height: auto;
        border: 1px solid #bfc9d4;
        color: #3b3f5c;
        font-size: 15px;
        letter-spacing: 1px;
        padding: 0.75rem 1.25rem;
        border-radius: 6px;
        line-height: 19px;
    }
    
    .input-weight-error {
        border-color: #e74c3c;
    }
</style>
    
